import React from "react";
import BadgeOrigineFranceTravail, {
  estOrigineFranceTravail,
} from "../../BadgeOrigineFranceTravail";
import BadgeDemandeSuspensionRemobilisation, { aDemandeSuspensionRemobilisation } from "../../EncartDemandeSuspensionRemobilisation";
import { getPresenceDisplay, isOver62 } from "./inscriptionHelpers";

const InscriptionCardInfo = ({ inscription, index, hasDecision, isClosed }) => {
  const presence = getPresenceDisplay(inscription);
  const over62 = isOver62(inscription);

  return (
    <div className="d-flex align-items-start" style={{ gap: 10 }}>
      {/* Avatar */}
      {!isClosed && (
        <div
          className="d-flex align-items-center justify-content-center font-weight-bold flex-shrink-0"
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: hasDecision
              ? "linear-gradient(135deg, #22c55e, #16a34a)"
              : "linear-gradient(135deg, #e2e8f0, #cbd5e1)",
            color: hasDecision ? "#fff" : "#64748b",
            fontSize: 14,
            letterSpacing: 1,
          }}
        >
          {hasDecision ? (
            <i className="fa fa-check" style={{ fontSize: 16 }} />
          ) : (
            <span>{index + 1}</span>
          )}
        </div>
      )}
      <div style={{ minWidth: 0 }}>
        <div
          className="font-weight-bold text-truncate"
          style={{
            fontSize: 14,
            color: "#1e293b",
            maxWidth: 200,
          }}
        >
          {inscription.userRecipient?.fullname || "—"}
        </div>
        <div style={{ fontSize: 12, color: "#94a3b8" }}>
          NIR: {inscription.userRecipient?.nir || "—"}
        </div>
        <div style={{ fontSize: 12, color: "#94a3b8" }}>
          {inscription.userRecipient?.professionalSituation || "—"}
        </div>
        {/* Presence */}
        <div
          className="d-inline-flex align-items-center mt-1 px-2 py-1 rounded"
          style={{
            background: presence.bg,
            gap: 5,
          }}
        >
          <i
            className={`fa ${presence.icon}`}
            style={{ fontSize: 11, color: presence.color }}
          />
          <span
            style={{
              fontSize: 11,
              color: presence.color,
              fontWeight: 600,
            }}
          >
            {presence.label}
          </span>
        </div>
        {/* Alerts */}
        <div className="d-flex flex-wrap mt-1" style={{ gap: 4 }}>
          {over62 && (
            <span
              className="d-inline-flex align-items-center px-2 py-1 rounded"
              style={{
                background: "#fef3c7",
                fontSize: 11,
                color: "#92400e",
                fontWeight: 600,
                gap: 4,
              }}
            >
              <i
                className="fa fa-exclamation-triangle"
                style={{ fontSize: 10 }}
              />
              +62 ans
            </span>
          )}
          {inscription.pregnancy && (
            <span
              className="d-inline-flex align-items-center px-2 py-1 rounded"
              style={{
                background: "#fce7f3",
                fontSize: 11,
                color: "#9d174d",
                fontWeight: 600,
                gap: 4,
              }}
            >
              <i className="fa fa-baby" style={{ fontSize: 10 }} />
              Grossesse
            </span>
          )}
          {estOrigineFranceTravail(inscription) && <BadgeOrigineFranceTravail />}
          {aDemandeSuspensionRemobilisation(inscription) && (
            <BadgeDemandeSuspensionRemobilisation
              demandeSuspensionRemobilisation={inscription.demandeSuspensionRemobilisation}
              allocataireNom={inscription.userRecipient?.fullname}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InscriptionCardInfo;
